import styled from '@emotion/styled';
import { oldTheme } from '../shared/old-styles';

export const RThirdTitle = styled.div`
  ${oldTheme.fontWeight.bold};
  color: ${oldTheme.darkGray};
  font-size: ${oldTheme.fontSize.l};
  margin-bottom: ${oldTheme.spacing.xs};
`;
